import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Exterior from "./sections/Exterior";
import Accreditations from "./sections/Accreditations";
import Expertise from "./sections/Expertise";
import Estimator from "./sections/Estimator";
import Expertisecards from "./sections/Expertisecards";
import Transformation from "./sections/Transformation";
import Portfolio from "./sections/Portfolio";
import Testimonials from "./sections/Testimonials";
import ServiceArea from "./sections/ServiceArea";
import Estimate from "./sections/Estimate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Exterior />
      <Accreditations />
      <Expertise />
      <Estimator />
      <Expertisecards />
      <Transformation />
      <Portfolio />
      <Testimonials />
      <ServiceArea />
      <Estimate />
      <Footer />
    </div>;
}